export default {
  scheduler: 'Planer',
  'scheduler.info': 'Planer-Informationen',
  'scheduler.header.title': '{{entity}}-Planer ({{count}})',
  'scheduler.result':
    'Findet <strong>{{occurs}}</strong> statt, beginnend am {{startAt}}.',
  'scheduler.startedAt': 'Gestartet am',
  'scheduler.duration': 'Wiederholen alle',
  'scheduler.occurrences': 'Vorkommnisse',
  'scheduler.weekdays.sunday': 'Sonntag',
  'scheduler.weekdays.monday': 'Montag',
  'scheduler.weekdays.tuesday': 'Dienstag',
  'scheduler.weekdays.wednesday': 'Mittwoch',
  'scheduler.weekdays.thursday': 'Donnerstag',
  'scheduler.weekdays.friday': 'Freitag',
  'scheduler.weekdays.saturday': 'Samstag',
  'scheduler.weekdays.short.sunday': 'So',
  'scheduler.weekdays.short.monday': 'Mo',
  'scheduler.weekdays.short.tuesday': 'Di',
  'scheduler.weekdays.short.wednesday': 'Mi',
  'scheduler.weekdays.short.thursday': 'Do',
  'scheduler.weekdays.short.friday': 'Fr',
  'scheduler.weekdays.short.saturday': 'Sa',
  'scheduler.duration.end': 'Endgrund',
  'scheduler.duration.endDate': 'Enddatum',
  'scheduler.duration.end.day': 'An diesem Tag',
  'scheduler.duration.end.after': 'Nach',
  'scheduler.duration.end.no': 'Kein Endtag',
  'scheduler.separator.and': ' und',
  'scheduler.separator.on': 'am',
  'scheduler.separator.day': 'Tag',
  'scheduler.separator.every': 'jeden',
  'scheduler.separator.of': 'von',
  'scheduler.separator.the': 'dem',
  'scheduler.day.first': 'Erster',
  'scheduler.day.second': 'Zweiter',
  'scheduler.day.third': 'Dritter',
  'scheduler.day.fourth': 'Vierter',
  'scheduler.day.last': 'Letzter',
  'scheduler.weekday': 'Wochentag',
  'scheduler.weekend': 'Wochenendtag',
  'scheduler.day': 'Tag',
  'scheduler.days': 'Tage',
  'scheduler.week': 'Woche',
  'scheduler.weeks': 'Wochen',
  'scheduler.year': 'Jahr',
  'scheduler.years': 'Jahre',
  'scheduler.monthDay': 'Tag des Monats',
  'scheduler.month': 'Monat',
  'scheduler.months': 'Monate',
  'scheduler.months.january': 'Januar',
  'scheduler.months.february': 'Februar',
  'scheduler.months.march': 'März',
  'scheduler.months.april': 'April',
  'scheduler.months.may': 'Mai',
  'scheduler.months.june': 'Juni',
  'scheduler.months.july': 'Juli',
  'scheduler.months.august': 'August',
  'scheduler.months.september': 'September',
  'scheduler.months.october': 'Oktober',
  'scheduler.months.november': 'November',
  'scheduler.months.december': 'Dezember',
  'scheduler.months.short.january': 'Jan',
  'scheduler.months.short.february': 'Feb',
  'scheduler.months.short.march': 'Mär',
  'scheduler.months.short.april': 'Apr',
  'scheduler.months.short.may': 'Mai',
  'scheduler.months.short.june': 'Jun',
  'scheduler.months.short.july': 'Jul',
  'scheduler.months.short.august': 'Aug',
  'scheduler.months.short.september': 'Sep',
  'scheduler.months.short.october': 'Okt',
  'scheduler.months.short.november': 'Nov',
  'scheduler.months.short.december': 'Dez',
  'scheduler.actions.manage': 'Planer verwalten',
  'scheduler.meta.assignedTo': 'Zugewiesen an',
  'scheduler.meta.duration': 'Dauer',
  'scheduler.meta.period': 'Zeitraum',
  'scheduler.limited': 'Der Planer ist begrenzt auf: {{limit}}',
  'scheduler.info.helper':
    'Stellen Sie den Planer ein, um einen Verkaufszeitraum festzulegen.',
};
